<div class="container-fluid pt-3 pb-5">
  <div class="row">
    <div class="col-md-3">
      <div class="card mb-3" style="border: 1px solid #ccc; border-radius: 5px;">
        <div class="card-header" style="background: #2b3a4a; color: white; padding: 10px; font-weight: bold;">
          Account Menu
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item"><a routerLink="/account" style="color: #2b3a4a; text-decoration: none; font-weight: bold;">My Profile</a></li>
          <li class="list-group-item"><a routerLink="/bet-history" style="color: #555; text-decoration: none;">Bet History</a></li>
          <li class="list-group-item"><a routerLink="/profit-loss" style="color: #555; text-decoration: none;">Profit & Loss</a></li>
          <li class="list-group-item"><a routerLink="/account-statement" style="color: #555; text-decoration: none;">Account Statement</a></li>
          <li class="list-group-item"><a routerLink="/activity-log" style="color: #555; text-decoration: none;">Activity Log</a></li>
        </ul>
      </div>
    </div>
    
    <div class="col-md-9">
      <div class="card" style="border: 1px solid #ccc; border-radius: 5px;">
        <div class="card-header" style="background: #2b3a4a; color: white; padding: 10px; font-weight: bold;">
          Account Details
        </div>
        <div class="card-body">
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th style="width: 30%; background: #f8f9fa;">Wallet Balance</th>
                <td><strong style="color: #28a745;">0.00</strong></td>
              </tr>
              <tr>
                <th style="background: #f8f9fa;">Total Exposure</th>
                <td><strong style="color: #dc3545;">0.00</strong></td>
              </tr>
              <tr>
                <th style="background: #f8f9fa;">Available Balance</th>
                <td><strong>0.00</strong></td>
              </tr>
              <tr>
                <th style="background: #f8f9fa;">Currency</th>
                <td>PTS</td>
              </tr>
            </tbody>
          </table>
          
          <div class="mt-4">
            <h5>Settings</h5>
            <hr />
            <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#changePasswordModal" style="background: #2b3a4a; border: none;">Change Password</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
